import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from "./App";
import reportWebVitals from './reportWebVitals';
import About from "./components/About";
import Products from "./components/Product";
import { productData } from "./components/data";
import Menu from "./components/Menu";
import { Element } from 'react-scroll';
import Navbar from "./pages/navbar/Navbar";
import { HelmetProvider } from "react-helmet-async";


ReactDOM.render(
  <HelmetProvider>
  <Router>
    <Navbar/>
    <Routes>
      <Route path="/" element={<Element name="home"><App /></Element>} />
      <Route path="/about" element={<Element name="about"><About /></Element>} />
      <Route path="/products" element={<Element name="products"><Products heading="Product List" data={productData} /></Element>} />
      <Route path="/contact" element={<Element name="contact"><Menu /></Element>} />
    </Routes>
  </Router>
  </HelmetProvider>,
  document.getElementById("root")
);

reportWebVitals();
